import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Calendar icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Calendar } from '@sravni/design-system-icons'
 *
 * <Calendar />
 * ```
 */
var Calendar = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Calendar", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16 3.75H4c-.69 0-1.25.56-1.25 1.25v11c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25Z", stroke: "currentColor", strokeWidth: "1.5" }),
    React.createElement("path", { d: "M14.25 10.5h-8.5a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5ZM17.25 7.5H2.75a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5ZM7.5 2.75a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0v-2.5ZM14 2.75a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0v-2.5ZM14.25 13.5h-8.5a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5Z", fill: "currentColor" }))); });

export { Calendar };
//# sourceMappingURL=Calendar.js.map
